module.exports = __webpack_public_path__ + "public/img/pro_build.a88c86bc.gif";